<script>
import Layout from "@layouts/main-fluid";
import api from "@services/api";
import TarefaLista from "@components/TarefaLista";

export default {
  page: {
    title: "Tarefas"
  },
  components: {
    Layout,
    TarefaLista
  },
  data: () => ({
    title: "Tarefas",
    items: [
      {
        text: "Tarefas",
        href: "/Tarefas",
        active: true
      }
    ],
    clienteId: null,
    projetoList: null,
    tarefaList: null,
    projetoId: null,
    clienteList: {},
    contratoList: {},
    clienteContratoList: {},
    contratoId: null,
    filtrarTarefasAtivas: true
    
  }),
  created() {
    // TODO dispacth filter
    // this.projetoId = this.filters["Tarefas.projetoId"];
    // this.clienteId = this.filters["Tarefas.clienteId"];    
    this.projetoId = null;
    this.clienteId = null;
    if (
      this.user.perfil === "Administrador" ||
      this.user.perfil === "Consultor"
    ) {
      this.getClienteList();
    }
    this.getProjetoList();
    this.getClienteContratoList();
  },
  watch: {
    clienteId: function() {      
      if(this.clienteId != -1 ) {        
        this.getProjetoList();
        this.getClienteContratoList();
      } 
      else
      {
        this.clienteId = undefined;
        this.projetoId = null;
        this.projetoList = null;
      }
      
      //TODO dispatchh clienteId
      // this.$store.dispatch("filter/save", [
      //   { type: "Tarefas.clienteId", value: this.clienteId }
      // ]);
    }
  },
  computed: {
    filters() {
      return this.$store.state.filter.filters;
    },
    user() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    getClienteList() {
      api
        .get(`api/Tarefa/Clientes`)
        .then(response => (this.clienteList = response.data["data"]));
    },
    getProjetoList() {
      if (
        ((this.user.perfil === "Administrador" ||
          this.user.perfil === "Consultor") &&
          this.clienteId) ||
        this.user.perfil === "Cliente"
      ) {
        api
          .get(`crud/projeto/listaProjetos`, {
            params: {
              clienteId: this.clienteId              
            }
          })
          .then(response => {
            this.projetoList = response.data["data"];
          });
      }
    },    
    getClienteContratoList() {         
      api.get(`crud/Contrato/listaContratos`,{
        params: {          
          clienteId: this.clienteId           
        }
        
      }).then(response => {
        this.contratoList = response.data["data"];        
      });      
        
    }
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <b-form-group
              class="col-md-3"
              id="input-group-1"
              label="Cliente"
              label-for="clienteId"
              v-if="user.perfil === 'Administrador'"
            >
              <b-form-select id="clienteId" v-model="clienteId">
                <b-form-select-option disabled :value="null"
                  >Selecione um item da lista cliente</b-form-select-option
                >
                <b-form-select-option
                  v-for="option in clienteList"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.nome }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group
              class="col-md-3"
              id="input-group-1"
              label="Projeto"
              label-for="projetoId"
            >
              <b-form-select id="projetoId" v-model="projetoId">
                <b-form-select-option :value="null"
                  >Selecione um item da lista</b-form-select-option
                >
                <b-form-select-option
                  v-for="option in projetoList"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.descricao }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group
              class="col-md-3"
              id="input-group-1"
              label="Contrato"
              label-for="contratoId"
            >
              <b-form-select
                id="contratoId"
                v-model="contratoId"                
              >
                <b-form-select-option  :value="null"
                  >Selecione um item da lista</b-form-select-option
                >
                <b-form-select-option
                  v-for="option in contratoList"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.descricao }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group >
                <b-form-checkbox
                id="ativo"
                class=" mt-4 ml-3"
                v-model="filtrarTarefasAtivas"            
                >Exibir Apenas Ativos
                </b-form-checkbox>
              </b-form-group>  
          </div>
          <TarefaLista  :clienteId="clienteId" :projetoId="projetoId" :contratoId="contratoId" :filtrarTarefasAtivas="filtrarTarefasAtivas"  />
        </div>
      </div>
    </div>
  </Layout>
</template>
